
























import { Component, Vue, PropSync, Prop, Emit } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class RangePicker extends Vue {
  @PropSync('start') private startDate!: moment.Moment
  @PropSync('end') private endDate!: moment.Moment
  @Prop() private readonly minDate!: moment.Moment
  @Prop() private readonly maxDate!: moment.Moment
  @Prop() private readonly disabled!: boolean

  private endOpen = false

  private disabledStartDate(current): boolean {
    const end = this.endDate
    if (this.minDate) {
      if (!end) {
        return current < this.minDate.startOf('day')
      }
      return current > end || current < this.minDate.startOf('day')
    } else {
      if (end) {
        return current > end
      }
    }
    return false
  }

  private disabledEndDate(current): boolean {
    const start = this.startDate
    if (this.minDate) {
      if (!start) {
        return current > this.maxDate.endOf('day')
      }
      return current < start || current > this.maxDate.endOf('day')
    } else {
      if (start) {
        return current < start
      }
    }
    return false
  }

  @Emit()
  private changeDateRange(date): void {}

  private handleStartOpenChange(open): void {
    if (!open) {
      this.endOpen = true
    }
  }

  private handleEndOpenChange(open): void {
    this.endOpen = open
    this.$nextTick(() => {
      this.changeDateRange([this.startDate, this.endDate])
    })
  }
}
